import { useAppSelector } from "../app/store";

type RolePath = Record<string, Record<string, string>>;

// Define role-to-path mapping in one place
const rolePaths: RolePath = {
  super_admin: {
    dashboard: "/admin/dashboard",
    ticket: "/admin/ticket-management",
    communication: "/admin/communication",
  },
  Admin: {
    dashboard: "/admin/dashboard",
    ticket: "/admin/ticket-management",
    communication: "/admin/communication",
  },
  User: {
    dashboard: "/user/dashboard",
    ticket: "/user/ticket-management",
    communication: "/user/communication",
  },
};

const useRoleBasedPath = () => {
  const { role } = useAppSelector((state) => state.auth);

  // Fallback to "User" paths if role not found
  const rolePath = rolePaths[(role || "User") as keyof typeof rolePaths];
  const { dashboard, ticket, communication } = rolePath;

  return {
    dashboardPath: dashboard,
    ticketPath: ticket,
    communicationPath: communication,
  };
};

export default useRoleBasedPath;
